<!--    This needs to be integrated with the header in customer-header.html and organization-customer.html (from pkrey)  -->
<header class="header--page" *ngIf="!inModal">
    <ul class="header__nav">
        <li class="header__back" title="Back to Results">
            <a class="icon--back-results" href="javascript:void(0);" (click)="navigateBack()" [ngClass]="{hidden: !showBack}"></a>
        </li>
        <li class="header__individual">
            <h1 class="header__circle">
                <customer-photo title="View Photo" [classes]="'mvd_photo--header'" [customerNumberId]="individualDetails.id" [legacySequenceNumber]="legacySequenceNumber" (click)="showPhotoModal()"></customer-photo>
                <span class="header__block" href="javascript:void(0)">{{individualDetails.nameDetail.firstName}} {{individualDetails.nameDetail.middleName}} {{individualDetails.nameDetail.lastName}} {{getValues(individualDetails.nameDetail.customerIndividualNameSuffixTypeId, nameSuffixTypes)}}<span class="header__block__sub">id: {{ individualDetails.id }} &nbsp; <ng-container *ngIf="null != individualDetails && null != individualDetails.biometric">{{ (individualDetails.biometric && individualDetails.biometric.isBiometricRedacted) ? '******' : individualDetails.biometric.dateOfBirth | shortDate }}</ng-container></span></span>
            </h1>
        </li>
        <li class="header__pages">
            <ul class="header__pages__links">
                <li [ngClass]="{isActive: tabs.Customer == tab }">
                    <a class="list__link" href="javascript:void(0);" title="Customer" (click)="changeTab(tabs.Customer)"><i class="material-icons">person</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.DriverInformation == tab }">
                    <a class="list__link" href="javascript:void(0);" title="Driver Information" (click)="changeTab(tabs.DriverInformation)"><i class="material-icons">badge</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.Vehicle == tab}">
                    <a class="list__link" href="javascript:void(0);" title="Vehicles" (click)="changeTab(tabs.Vehicle)"><i class="material-icons">directions_car</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.MVDNow == tab}">
                    <a class="list__link list__link__logo-mvd" href="javascript:void(0);" title="AZ MVD Now" (click)="changeTab(tabs.MVDNow)"></a>
                </li>
                <li [ngClass]="{isActive: tabs.Accounts == tab}" *ngIf="individualDetails.level >= 3">
                    <a class="list__link" href="javascript:void(0);" title="Accounts" (click)="changeTab(tabs.Accounts)"><i class="material-icons">work</i><sup>{{numberOfAccounts}}</sup></a>
                </li>
                <li [ngClass]="{isActive: tabs.Affiliations == tab}">
                    <a class="list__link" href="javascript:void(0);" title="Affiliations" (click)="changeTab(tabs.Affiliations)"><i class="material-icons">group</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.Documents == tab}">
                    <a class="list__link" href="javascript:void(0);" title="Documents" (click)="changeTab(tabs.Documents)"><i class="material-icons">description</i></a>
                </li>
                <li>
                    <a class="list__link" href="javascript:void(0);" title="Notes" (click)="openNotesModal()"><i class="material-icons">note</i><sup><span class="note-count"></span></sup></a>
                </li>
                <li *ngIf="auth.hasSecurityTransactionClaim(securityTransactionType.CustomerSurveySendSMS)">
                    <a class="list__link" href="javascript:void(0);" title="Send Customer Survey" (click)="openSendCustomerSurveyModal()"><i class="material-icons">reviews</i></a>
                </li>
                <li>
                    <a class="list__link" href="javascript:void(0);" title="Create An Appointment" (click)="createAppointment()"><i class="material-icons">today</i></a>
                </li>
            </ul>
        </li>
    </ul>
</header>

<div [ngClass]="{mvd_container: !inModal}" [ngSwitch]="tab">
    <ng-container *ngSwitchCase="tabs.Customer">
        <header class="header--well">
            <ul>
                <li class="header__title" *ngIf="!inModal">
                    <h2>{{title}} <span class="deceased"><ng-container *ngIf="deceased && individualDetails.statusTypeId != customerStatusTypes.Closed.id">(Deceased) </ng-container><ng-container *ngIf="individualDetails.statusTypeId == customerStatusTypes.Closed.id">Do Not Use This Record</ng-container></span></h2>
                </li>
                <li>
                    <ul class="list--views">
                        <li *ngIf="transactionId != 0">
                            <a class="list__link" href="javascript:void(0);" (click)="backToTransaction()">Back to Transaction</a>
                        </li>
                        <li>
                            <a class="list__link" href="javascript:void(0);" (click)="toggleView()">{{titleLink}}</a>
                        </li>
                        <li>
                            <a class="list__link" href="javascript:void(0);" (click)="changeTab(tabs.CustomerServiceHistory)">View Service History</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </header>
        <div class="well">
            <div class="list--ancors" *ngIf="showAll && !inModal">
                <ul class="list--menu">
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Name')">Name</a>
                    </li>

                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('CustomerDetails')">Customer</a>
                    </li>

                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Address')">Addresses</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Identification')">Identifications</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Contact')">Contacts</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Certification')">Certifications</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Characteristic')">Characteristics</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Attribute')">Physical Attributes</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Medical')">Medical Alert</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Placard')">Placards</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Insurance')">Insurance</a>
                    </li>
                </ul>
            </div>
            <customer-names id="Name" [names]="names" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustName.id]"></customer-names>
            <individual-customer-details id="CustomerDetails"
                                [details]="details"
                                [customerNumber]="individualDetails.id"
                                [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustDetail.id]"
                                (deceasedChanged)="deceasedChanged($event)"
								(customerStatusTypeIdChanged)="statusChanged($event)">
            </individual-customer-details>
            <address-component id="Address"
                               [addresses]="individualDetails.addresses"
                               [entityId]="individualDetails.id"
                               [componentTitle]="'Addresses'"
                               [componentTypeName]="'individual-customer'"
                               [canEdit]="canEditAddress"
                               [canSetUndeliverable]="individualDetails.accessControls[accessControlTypes.SetAddressUndeliverable.id]"
                               [showHistoryButton]="true"
                               [isACP]="individualDetails.isACP"
                               (onAddressesUpdated)="customerAddressesUpdated($event)">
            </address-component>
            <customer-identification id="Identification" [identifications]="individualDetails.identifications" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustIdentification.id]" [canEditLegacyCustomerNumber]="individualDetails.accessControls[accessControlTypes.UpdLegacyCustNumberIdType.id]" (ssnChanged)="reloadData($event)"></customer-identification>
            <customer-contact id="Contact" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustContact.id]" [isFullRedactionNecessary]="isFullRedactionNecessary" (onContactChange)="reloadData($event)"></customer-contact>
            <ng-container *ngIf="showAll">
                <customer-certification id="Certification" [certifications]="individualDetails.certifications" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustCertification.id]" (onCertificationsChange)="reloadData($event)"></customer-certification>
                <customer-characteristic id="Characteristic"
                    [deceased]="deceased" [characteristics]="individualDetails.characteristics"
                    [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustCharacteristic.id]"
                    [canRemove]="individualDetails.accessControls[accessControlTypes.CanRemoveACPCharacteristic.id]"
                    [canEditRedactedRecord]="canEditRedactedRecord" (acpChanged)="acpChanged($event)"
                    (onCharacteristicChange)="reloadData($event)"></customer-characteristic>
                <customer-attributes id="Attribute" [attribute]="individualDetails.biometric" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustPhysicalAttributes.id]"></customer-attributes>
                <customer-medical-alerts id="Medical" [alerts]="individualDetails.medicalAlerts" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustMedical.id]" (onMedicalAlertsChange)="reloadData($event)"></customer-medical-alerts>
                <customer-placard id="Placard" [placards]="" [customerNumber]="individualDetails.id"></customer-placard>
                <customer-insurance id="Insurance" [customerNumber]="individualDetails.id"></customer-insurance>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="tabs.DriverInformation">
        <header class="header--well">
            <ul>
                <li class="header__title">
                    <h2>Driver Information</h2>
                </li>
                <li>
                    <ul class="list--views">
                        <a [routerLink]="['/driverrecord', customerNumber]" [queryParams]="{ return: 'c0' }">View Driver Record</a>
                    </ul>
                </li>
            </ul>
        </header>
        <div class="well">
            <driver-record-credentials [customerNumberId]="customerNumber"></driver-record-credentials>
            <commercial-intent-table [customerNumberId]="customerNumber" [actionsEnabled]="false"></commercial-intent-table>
            <customer-mrp-certificates [customerNumberId]="customerNumber" [editorEnabled]="false"></customer-mrp-certificates>
            <tsa-security-threat-history [customerNumberId]="customerNumber" [editorEnabled]="false" [showHistoryEnabled]="true"></tsa-security-threat-history>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="tabs.Vehicle">
        <header class="header--well" *ngIf="!inModal">
            <ul>
                <li class="header__title">
                    <h2>Vehicle Summary</h2>
                </li>
            </ul>
        </header>

        <div class="well">
            <customer-vehicle (vehicleSelected)="changeTab(tabs.VehicleDetails, $event)" [vehicles]="individualDetails.vehicles" [customerNumber]="individualDetails.id"></customer-vehicle>
            <customer-fleet [customerNumber]="individualDetails.id" [customerTypeId]="customerTypes.Individual.id"></customer-fleet>
        </div>
    </ng-container>
    <mvdnow-view *ngSwitchCase="tabs.MVDNow" [customerNumber]="individualDetails.id" (documentSelected)="changeTab(tabs.Documents)"></mvdnow-view>
    <customer-account-summary *ngSwitchCase="tabs.Accounts" (accountClicked)="changeTab(tabs.AccountDetails, $event)" (accountCreated)="changeTab(tabs.AccountEdit, $event)" [customerNumber]="individualDetails.id"></customer-account-summary>
    <customer-account-details *ngSwitchCase="tabs.AccountDetails" (editClicked)="changeTab(tabs.AccountEdit, $event)" (requestDisbursementClicked)="changeTab(tabs.DisbursementRequest, $event)" (serviceHistoryClicked)="changeTab(tabs.ServiceHistory, $event)" [customerAccountNumber]="customerAccountNumberId"></customer-account-details>
    <edit-customer-account *ngSwitchCase="tabs.AccountEdit" [customerAccountNumber]="customerAccountNumberId" (navigateBack)="navigateBack()"></edit-customer-account>
    <disbursement-request *ngSwitchCase="tabs.DisbursementRequest" [customerAccountNumberId]="customerAccountNumberId" [customerNumberId]="customerNumber" [names]="names" (navigateBack)="navigateBack()"></disbursement-request>
    <customer-account-transaction-search *ngSwitchCase="tabs.ServiceHistory" [customerAccountNumberId]="customerAccountNumberId"></customer-account-transaction-search>
    <customer-affiliation *ngSwitchCase="tabs.Affiliations" [customerNumber]="individualDetails.id" [canEdit]="individualDetails.accessControls[accessControlTypes.UpdCustAffiliations.id]"></customer-affiliation>
    <vehicle-information *ngSwitchCase="tabs.VehicleDetails" [vehicleId]="vehicleDetailId" [includeHeader]="false"></vehicle-information>

    <div class="well" *ngSwitchCase="tabs.Documents">
        <document-retrieve-upload [searchDocumentDataCollection]="searchDocumentDataCollection" [hideCloseButton]="true"></document-retrieve-upload>
    </div>

    <div class="well" *ngSwitchCase="tabs.CustomerServiceHistory">
        <form [formGroup]="form">
            <h2>Search for Service History</h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-3 col-lg-2 mvd_form-group">
                        <label>Start Date</label>
                        <p-calendar placeholder="mm/dd/yyyy" formControlName="startDate" [showIcon]="true" [maxDate]="maxStartDate" (onSelect)="onStartDateChanged($event)" dateFormat="mm/dd/yy"></p-calendar>
                        <control-validation-messages control="startDate"></control-validation-messages>
                        <div class="mvd_alert__validation" *ngIf="form.hasError('startAfterEndDate')">
                            <div class="mvd_alert__rule">Start date cannot be after End date</div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-lg-2 mvd_form-group">
                        <label>End Date</label>
                        <p-calendar placeholder="mm/dd/yyyy" formControlName="endDate" [showIcon]="true" [maxDate]="maxEndDate" dateFormat="mm/dd/yy"></p-calendar>
                        <control-validation-messages control="endDate"></control-validation-messages>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8 col-md-5 mvd_form-group">
                         <label for="businessUnitId" >Business Unit</label>
                        <p-dropdown [options]="businessUnits" formControlName="businessUnitId" filter="filter"></p-dropdown>
                    </div>
                    <div class="col-sm-8 col-md-4 mvd_form-group">
                         <label for="businessTransactionTypeId">Business Transaction Type</label>
                        <p-dropdown [options]="businessTransactionTypes" formControlName="businessTransactionTypeId" filter="filter"></p-dropdown>
                    </div>
                    <div class="mvd_form-txt">
                        Or
                    </div>
                    <div class="col-sm-3 col-md-2 mvd_form-group">
                        <label for="receiptId">Receipt #</label>
                            <input class="mvd_form-control" id="receiptId" type="number" autocomplete="off" formControlName="receiptId" />
                        <control-validation-messages control="receiptId"></control-validation-messages>
                    </div>
                </div>
            </fieldset>
            <div class="well__footer">
                <div class="btn--group">
                    <button type="button" class="btn--default" (click)="resetSearch()" [disabled]="inProgress">Reset</button>
                    <button type="submit" class="btn--primary" (click)="search()" [disabled]="inProgress">Find</button>
                </div>
            </div>
        </form>
        <div class="divider" *ngIf="customerServiceHistorysearchResults">
            <h2>Service History Results</h2>
            <p-table #dt
                     #table
                     [value]="customerServiceHistorysearchResults"
                     [columns]="cols"
                     [rows]="rows"
                     [paginator]="true"
                     [lazy]="true"
                     [totalRecords]="totalRecords"
                     [lazyLoadOnInit]="false"
                     (onLazyLoad)="loadDataLazy($event)"
                     [globalFilterFields]="['receiptId', 'businessTransactionCompletionDate', 'businessUnit', 'businessTransactionType', 'businessTransactionDetails', 'agent', 'customerName']"
                     styleClass="p-datatable-striped mvd_table--notfixed">
                <ng-template pTemplate="caption">
                    <div class="row">
                        <div class="col-sm-6 col-md-3">
                            <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="9">
                            No records found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th class="w--actions">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr [pSelectableRow]="data">
                        <td>{{ data.receiptId }}</td>
                        <td>{{ data.businessTransactionCompletionDate | date:'M/d/yyyy' }}</td>
                        <td>{{ data.businessUnit }}</td>
                        <td>{{ data.businessTransactionType }}</td>
                        <td>{{ data.businessTransactionDetails }}</td>
                        <td>{{ data.agentName }}</td>
                        <td>{{ data.customerName }}</td>
                        <td class="text-right">{{ data.amount | currency:'USD':'symbol-narrow':'.2-2' }}</td>
                        <td class="text-center">
                            <div class="icon--spinner loading" title="Processing" *ngIf="data.wipStatusTypeId === null"></div>
                            <a class="icon--upload" title="Upload Documents" (click)="launchDocuments(data.businessTransactionNumber)" href="javascript:void(0);"></a>
                            <a class="icon--alert--retry" href="javascript:void(0);" title="Retry" (click)="retryCompleteBusinessTransaction(data)" *ngIf="wipStatusType.AwaitingPostFinalize.id == data.wipStatusTypeId"><i class="material-icons">error</i></a>
                            <a class="icon--select" title="Select Service" (click)="getArtifacts(data.businessTransactionNumber, data.businessTransactionDetails)" *ngIf="wipStatusType.ServiceComplete.id == data.wipStatusTypeId" href="javascript:void(0);"></a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<div class="list--ancors__spacer" *ngIf="showAll && !inModal"></div>
